"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayDate = exports.sortNodesByDepth = exports.getSelectedItems = exports.getFilteredNodes = exports.prepareDataForTable = exports.toggleNodeExpansion = exports.isAnyOneCheckedOrIndeterminate = exports.areAllChildrenChecked = exports.findAndUpdateCheckedStatus = exports.getAllTheChildren = exports.getNodesToRender = exports.flattenTree = void 0;

var _clone = _interopRequireDefault(require("lodash/clone"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var flattenTree = function flattenTree(tree) {
  var treeArr = Array.isArray(tree) ? tree : [tree];
  return traverseNodes({
    nodes: treeArr
  });
};

exports.flattenTree = flattenTree;

var traverseNodes = function traverseNodes(_ref) {
  var nodes = _ref.nodes,
      parent = _ref.parent,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth,
      _ref$flattennedList = _ref.flattennedList,
      flattennedList = _ref$flattennedList === void 0 ? [] : _ref$flattennedList,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path;
  nodes.forEach(function (node, i) {
    node._depth = depth;
    node.path = "".concat(path).concat(path.length ? '/' : '').concat(node === null || node === void 0 ? void 0 : node.label);

    if (parent) {
      node._id = node.id || "".concat(parent._id, "-").concat(i);
      node._parent = parent._id;

      parent._children.push(node._id);
    } else {
      node._id = node.id || "".concat(i);
    }

    flattennedList.push(node);

    if (node.nodes) {
      node._children = [];
      traverseNodes({
        nodes: node.nodes,
        parent: node,
        depth: depth + 1,
        flattennedList: flattennedList,
        path: node.path
      });
    }
  });
  return flattennedList;
};

var getNodesToRender = function getNodesToRender(allNodes) {
  var _toBeTraversedNodes;

  var singleSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var rootLeafNodesFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var toBeTraversedNodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var traversedNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var nodesToRender = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (toBeTraversedNodes.length === 0) {
    toBeTraversedNodes = allNodes;
  }

  (_toBeTraversedNodes = toBeTraversedNodes) === null || _toBeTraversedNodes === void 0 ? void 0 : _toBeTraversedNodes.forEach(function (node) {
    if (!traversedNode.includes(node._id)) {
      var _node$_children;

      traversedNode.push(node._id);
      nodesToRender.push(node);

      if ((node === null || node === void 0 ? void 0 : (_node$_children = node._children) === null || _node$_children === void 0 ? void 0 : _node$_children.length) > 0) {
        if (node !== null && node !== void 0 && node.expanded) {
          var childrenNodes = allNodes.filter(function (child) {
            return node === null || node === void 0 ? void 0 : node._children.includes(child._id);
          });
          getNodesToRender(allNodes, singleSelect, rootLeafNodesFirst, childrenNodes, traversedNode, nodesToRender);
        } else {
          traversedNode.push.apply(traversedNode, _toConsumableArray(getAllTheChildren(allNodes, node._id)));
        }
      }

      if (node.checked && !singleSelect) {
        var _node$_children2;

        if ((node === null || node === void 0 ? void 0 : (_node$_children2 = node._children) === null || _node$_children2 === void 0 ? void 0 : _node$_children2.length) > 0) {
          updateAllChildren(allNodes, node === null || node === void 0 ? void 0 : node._children, node.checked);
        }

        updateParents(allNodes, node === null || node === void 0 ? void 0 : node._parent);
      }
    }
  });

  if (rootLeafNodesFirst && !(0, _isEmpty.default)(nodesToRender)) {
    /**
     * When the root level leaf nodes are to be moved up,
     * 1. Find the index from where the lead nodes are present.
     * 2. Keep the items from that index to the last in a variable. i.e. slice the array.
     * 3. Remove the root leaf nodes from the original array.
     * 4. Add the items from #2 to the index 1 of the array. 0th index is alway going to be the root.
     */
    var allNodesWithLeavesAtTop = (0, _clone.default)(nodesToRender);
    var fromIndexToRemove = allNodesWithLeavesAtTop.findIndex(function (node) {
      return node._depth === 1 && node.type === 'leaf' && node._parent === '0';
    });

    if (fromIndexToRemove !== -1) {
      var rootLevelLeaves = allNodesWithLeavesAtTop.slice(fromIndexToRemove);
      allNodesWithLeavesAtTop.splice(fromIndexToRemove);
      allNodesWithLeavesAtTop.splice.apply(allNodesWithLeavesAtTop, [1, 0].concat(_toConsumableArray(rootLevelLeaves)));
      return allNodesWithLeavesAtTop;
    }
  }

  return nodesToRender;
};

exports.getNodesToRender = getNodesToRender;

var getAllTheChildren = function getAllTheChildren(nodes, parentNodeId) {
  var _nodes$nodeIndex;

  var childrenIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var nodeIndex = nodes.findIndex(function (node) {
    return node._id === parentNodeId;
  });
  var children = ((_nodes$nodeIndex = nodes[nodeIndex]) === null || _nodes$nodeIndex === void 0 ? void 0 : _nodes$nodeIndex._children) || [];
  children.forEach(function (child) {
    childrenIds.push(child);
    getAllTheChildren(nodes, child, childrenIds);
  });
  return childrenIds;
};

exports.getAllTheChildren = getAllTheChildren;

var findAndUpdateCheckedStatus = function findAndUpdateCheckedStatus(nodeId, isChecked, nodes) {
  var singleSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var updatedNodes = _toConsumableArray(nodes);

  var nodeIndex = nodes.findIndex(function (node) {
    return node._id === nodeId;
  });

  if (singleSelect) {
    // If the single environment select is true, uncheck the any prechecked environment(s).
    var existingSelectedNodes = nodes.reduce(function (accumulator, node, index) {
      if (node.checked) {
        accumulator.push(index);
      }

      return accumulator;
    }, []);
    existingSelectedNodes.forEach(function (existingNodeIndex) {
      updatedNodes[existingNodeIndex].checked = false;
    });
    updatedNodes[nodeIndex].checked = isChecked;
    updatedNodes[nodeIndex].indeterminate = false;
  } else {
    var _nodes$nodeIndex3, _nodes$nodeIndex3$_ch, _nodes$nodeIndex5;

    var isCurrentNodeChecked = false;
    var isCurrentNodeIndeterminate = false;

    if (updatedNodes[nodeIndex].checked) {
      var _nodes$nodeIndex2, _nodes$nodeIndex2$_ch;

      isCurrentNodeChecked = false;
      isCurrentNodeIndeterminate = ((_nodes$nodeIndex2 = nodes[nodeIndex]) === null || _nodes$nodeIndex2 === void 0 ? void 0 : (_nodes$nodeIndex2$_ch = _nodes$nodeIndex2._children) === null || _nodes$nodeIndex2$_ch === void 0 ? void 0 : _nodes$nodeIndex2$_ch.length) > 0;
    } else if (!updatedNodes[nodeIndex].checked && updatedNodes[nodeIndex].indeterminate) {
      isCurrentNodeChecked = false;
      isCurrentNodeIndeterminate = false;
    } else {
      isCurrentNodeChecked = true;
      isCurrentNodeIndeterminate = false;
    }

    updatedNodes[nodeIndex].checked = isCurrentNodeChecked;
    updatedNodes[nodeIndex].indeterminate = isCurrentNodeIndeterminate;

    if (((_nodes$nodeIndex3 = nodes[nodeIndex]) === null || _nodes$nodeIndex3 === void 0 ? void 0 : (_nodes$nodeIndex3$_ch = _nodes$nodeIndex3._children) === null || _nodes$nodeIndex3$_ch === void 0 ? void 0 : _nodes$nodeIndex3$_ch.length) > 0) {
      var _nodes$nodeIndex4;

      updateAllChildren(updatedNodes, (_nodes$nodeIndex4 = nodes[nodeIndex]) === null || _nodes$nodeIndex4 === void 0 ? void 0 : _nodes$nodeIndex4._children, isCurrentNodeChecked, isCurrentNodeIndeterminate);
    }

    updateParents(updatedNodes, (_nodes$nodeIndex5 = nodes[nodeIndex]) === null || _nodes$nodeIndex5 === void 0 ? void 0 : _nodes$nodeIndex5._parent);
  }

  return updatedNodes;
};

exports.findAndUpdateCheckedStatus = findAndUpdateCheckedStatus;

var updateAllChildren = function updateAllChildren(nodes) {
  var childrenIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isChecked = arguments.length > 2 ? arguments[2] : undefined;
  var isParentIndeterminate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  childrenIds.forEach(function (id) {
    var _nodes$nodeIndex6, _nodes$nodeIndex6$_ch;

    var nodeIndex = nodes.findIndex(function (node) {
      return node._id === id;
    });

    if (nodeIndex === -1) {
      return;
    }

    nodes[nodeIndex].checked = isChecked || isParentIndeterminate;
    nodes[nodeIndex].indeterminate = false;
    nodes[nodeIndex].disabled = isChecked;

    if (((_nodes$nodeIndex6 = nodes[nodeIndex]) === null || _nodes$nodeIndex6 === void 0 ? void 0 : (_nodes$nodeIndex6$_ch = _nodes$nodeIndex6._children) === null || _nodes$nodeIndex6$_ch === void 0 ? void 0 : _nodes$nodeIndex6$_ch.length) > 0) {
      updateAllChildren(nodes, nodes[nodeIndex]._children, isChecked);
    }
  });
};

var updateParents = function updateParents(nodes, parentNodeId) {
  if (parentNodeId) {
    var nodeIndex = nodes.findIndex(function (node) {
      return node._id === parentNodeId;
    });
    var childrenIds = nodes[nodeIndex]._children || [];
    var children = nodes.filter(function (node) {
      return childrenIds.includes(node._id);
    });

    if (areAllChildrenChecked(children) && !nodes[nodeIndex].checked) {
      nodes[nodeIndex].indeterminate = true;
    } else if (!areAllChildrenChecked(children) && isAnyOneCheckedOrIndeterminate(children)) {
      nodes[nodeIndex].checked = false;
      nodes[nodeIndex].indeterminate = true;
    } else if (!areAllChildrenChecked(children)) {
      nodes[nodeIndex].checked = false;
      nodes[nodeIndex].indeterminate = false;
    }

    if (nodes[nodeIndex]._parent) {
      updateParents(nodes, nodes[nodeIndex]._parent);
    }
  }
};

var areAllChildrenChecked = function areAllChildrenChecked() {
  var childrenNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return childrenNodes.every(function (child) {
    return child.checked;
  });
};

exports.areAllChildrenChecked = areAllChildrenChecked;

var isAnyOneCheckedOrIndeterminate = function isAnyOneCheckedOrIndeterminate() {
  var childrenNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return childrenNodes.some(function (child) {
    return child.checked || child.indeterminate;
  });
};

exports.isAnyOneCheckedOrIndeterminate = isAnyOneCheckedOrIndeterminate;

var toggleNodeExpansion = function toggleNodeExpansion(nodes, nodeId) {
  var nodeIndex = nodes.findIndex(function (node) {
    return node._id === nodeId;
  });

  var updatedNodes = _toConsumableArray(nodes);

  updatedNodes[nodeIndex] = _objectSpread(_objectSpread({}, updatedNodes[nodeIndex]), {}, {
    expanded: !nodes[nodeIndex].expanded
  });
  return updatedNodes;
};

exports.toggleNodeExpansion = toggleNodeExpansion;

var prepareDataForTable = function prepareDataForTable(nodes, showSelected, searchText) {
  var updatedNodes = _toConsumableArray(nodes);

  if (showSelected) {
    updatedNodes = updatedNodes.filter(function (node) {
      return node.checked;
    });
  }

  if (searchText) {
    updatedNodes = updatedNodes.filter(function (node) {
      var _node$label, _node$label$toLowerCa;

      return (_node$label = node.label) === null || _node$label === void 0 ? void 0 : (_node$label$toLowerCa = _node$label.toLowerCase()) === null || _node$label$toLowerCa === void 0 ? void 0 : _node$label$toLowerCa.includes(searchText);
    });
  }

  return updatedNodes;
};

exports.prepareDataForTable = prepareDataForTable;

var getFilteredNodes = function getFilteredNodes(nodes, filter, searchText) {
  var singleSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var rootLeafNodesFirst = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var filteredNodes = _toConsumableArray(nodes);

  if (filter === _constants.SHOW_SELECTED) {
    filteredNodes = nodes.filter(function (node) {
      return node.checked || node.indeterminate;
    });
  }

  if (searchText) {
    filteredNodes = filterByText(filteredNodes, searchText, singleSelect, rootLeafNodesFirst);
  }

  return filteredNodes;
};

exports.getFilteredNodes = getFilteredNodes;

var filterByText = function filterByText(nodes, searchText, singleSelect, rootLeafNodesFirst) {
  var nodesWithMachingText = nodes.filter(function (node) {
    var _node$label2, _node$label2$toLowerC;

    return (_node$label2 = node.label) === null || _node$label2 === void 0 ? void 0 : (_node$label2$toLowerC = _node$label2.toLowerCase()) === null || _node$label2$toLowerC === void 0 ? void 0 : _node$label2$toLowerC.includes(searchText);
  });
  var filteredNodes = [];
  var traversedNodes = [];
  nodesWithMachingText.forEach(function (node) {
    if (node._parent && !traversedNodes.includes(node._parent)) {
      var parentsList = getParentsForANode(nodes, node, traversedNodes);
      filteredNodes.push.apply(filteredNodes, _toConsumableArray(parentsList));
    }

    traversedNodes.push(node._id);
    filteredNodes.push(node);
  }); // Sorting the nodes by depth to start the rendering in the corect order.

  return getNodesToRender(_toConsumableArray(sortNodesByDepth(filteredNodes)), singleSelect, rootLeafNodesFirst);
};

var getParentsForANode = function getParentsForANode(nodes, selectedNode, traversedNodes) {
  var parents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var nodeIndex = nodes.findIndex(function (node) {
    return node._id === selectedNode._parent;
  });

  if (nodeIndex !== -1 && !traversedNodes.includes(selectedNode._parent)) {
    var _nodes$nodeIndex7;

    parents.push(nodes[nodeIndex]);
    traversedNodes.push(selectedNode._parent);

    if ((_nodes$nodeIndex7 = nodes[nodeIndex]) !== null && _nodes$nodeIndex7 !== void 0 && _nodes$nodeIndex7._parent) {
      getParentsForANode(nodes, nodes[nodeIndex], traversedNodes, parents);
    }
  }

  return parents;
};

var getSelectedItems = function getSelectedItems(nodes) {
  var traversedNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // Filter by checked values, and sort the list by depth.
  // Sorting is done to find the top-most parent quickly.
  var checkedNodes = sortNodesByDepth(nodes.filter(function (node) {
    return node.checked;
  }));
  var selectedItems = [];
  checkedNodes.forEach(function (checkedNode) {
    if (!traversedNodes.includes(checkedNode._id)) {
      // Find all the nodes matching the current node's path, or if the current node path is a substring.
      // This gives us the parent and all the associated children.
      var nodesMatchingCurrentPath = checkedNodes.filter(function (node) {
        return node.path === checkedNode.path || node.path.includes("".concat(checkedNode.path, "/"));
      });

      if (nodesMatchingCurrentPath[0].type === 'node') {
        // The first element is always going to be the top most parent.
        // Add that to the selectedItems.
        selectedItems.push(nodesMatchingCurrentPath[0]);
      } else {
        // If it is of the type leaf, then the rest of the items are also leaf.
        // Add all the matching items to the selectedItems.
        selectedItems.push.apply(selectedItems, _toConsumableArray(nodesMatchingCurrentPath));
      } // Add all the ids to the traversed list to prevent duplicates.


      traversedNodes.push.apply(traversedNodes, _toConsumableArray(nodesMatchingCurrentPath.map(function (node) {
        return node._id;
      })));
    }
  }); // Filter the unnecessary data from the nodes before passing it to the onChange function.

  return selectedItems.map(function (node) {
    return {
      label: node.label,
      value: node.value
    };
  });
};

exports.getSelectedItems = getSelectedItems;

var sortNodesByDepth = function sortNodesByDepth(nodes) {
  var sortedNodes = _toConsumableArray(nodes);

  sortedNodes.sort(function (a, b) {
    if (a._depth > b._depth) {
      return 1;
    }

    if (b._depth > a._depth) {
      return -1;
    }

    return 0;
  });
  return sortedNodes;
};

exports.sortNodesByDepth = sortNodesByDepth;

var getDisplayDate = function getDisplayDate(dateTime) {
  if (!dateTime) {
    return '';
  }

  var date = new Date(dateTime);
  var dateOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  };
  var timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short',
    hourCycle: 'h23'
  };
  var datePortion = date.toLocaleDateString('en-US', _objectSpread({}, dateOptions));
  var timePortion = date.toLocaleTimeString('en-US', _objectSpread({}, timeOptions));
  return "".concat(datePortion, ", ").concat(timePortion);
};

exports.getDisplayDate = getDisplayDate;